var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 96,
    viewBox: "0 0 81 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7913 41.3749L18.1683 6.71046C12.5125 3.05431 5.05371 7.11416 5.05371 13.8488L5.0537 48.5538L5.0537 82.3534C5.0537 89.0462 12.43 93.1136 18.09 89.5417L71.7131 55.7015C76.9639 52.3879 77.0057 44.7457 71.7913 41.3749Z",
    stroke: "white",
    strokeWidth: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.317ecbb71a676d52145fed178374db4c.svg";
export { ForwardRef as ReactComponent };